/** Picklist helpers shared by the Create / Update forms. */

import type { PicklistsOut, PickOut } from "@/shared/api/userAdmin";

export function toData(values: PickOut[]): { value: string; label: string }[] {
  return values.map((v) => ({
    value: v.value,
    label: v.label && v.label !== v.value ? `${v.label} (${v.value})` : v.value,
  }));
}

/** The picklist behind a Vault user field, or null for a free-text field. */
export function picklistFor(
  lists: PicklistsOut | null,
  field: string,
): { value: string; label: string }[] | null {
  if (!lists) return null;
  const map: Record<string, PickOut[]> = {
    security_profile__v: lists.security_profiles,
    license_type__v: lists.license_types,
    security_policy_id__v: lists.security_policies,
    user_timezone__v: lists.timezones,
    user_locale__v: lists.locales,
    user_language__v: lists.languages,
    active__v: [
      { value: "true", label: "Active" },
      { value: "false", label: "Inactive" },
    ],
    is_domain_admin__v: [
      { value: "true", label: "Yes" },
      { value: "false", label: "No" },
    ],
  };
  const values = map[field];
  return values && values.length > 0 ? toData(values) : null;
}

/** A Vault field value for display. */
export function fmtValue(value: unknown): string {
  if (value === null || value === undefined || value === "") return "—";
  if (typeof value === "object") return JSON.stringify(value);
  return String(value);
}
